(function(){
  if(window.__tsumeEarlyAccessSystemLoaded)return;
  window.__tsumeEarlyAccessSystemLoaded=true;

  var ACCESS_KEY='tsume_early_access_token_v2';
  var INVITE_PARAM='early_access';
  var SUPABASE_BASE='https://lycznxfofocarjxnigpk.supabase.co/functions/v1/';
  var OLD_HOLD=SUPABASE_BASE+'tsume-hold';
  var NEW_HOLD=SUPABASE_BASE+'tsume-hold-early';
  var OLD_CHECKOUT=SUPABASE_BASE+'tsume-checkout';
  var NEW_CHECKOUT=SUPABASE_BASE+'tsume-checkout-early';
  var ACCESS_URL=SUPABASE_BASE+'tsume-early-access';
  var nativeFetch=window.fetch.bind(window);
  var pendingInviteKey='';

  try{
    var currentUrl=new URL(window.location.href);
    pendingInviteKey=currentUrl.searchParams.get(INVITE_PARAM)||'';
    if(pendingInviteKey){
      currentUrl.searchParams.delete(INVITE_PARAM);
      var cleanUrl=currentUrl.pathname+(currentUrl.search||'')+(currentUrl.hash||'');
      window.history.replaceState(window.history.state,'',cleanUrl);
    }
  }catch(e){}

  function getAccessToken(){
    try{return localStorage.getItem(ACCESS_KEY)||''}catch(e){return ''}
  }
  function setAccessToken(token){
    try{if(token)localStorage.setItem(ACCESS_KEY,token);else localStorage.removeItem(ACCESS_KEY)}catch(e){}
  }
  function parseBody(body){
    if(typeof body!=='string')return null;
    try{return JSON.parse(body)}catch(e){return null}
  }
  function copyInit(init){
    var next={};
    Object.keys(init||{}).forEach(function(key){next[key]=init[key]});
    return next;
  }
  function targetUrl(input){
    if(typeof input==='string')return input;
    if(input&&typeof input.url==='string')return input.url;
    return '';
  }
  function rewriteUrl(url){
    if(url.indexOf(OLD_HOLD)===0)return NEW_HOLD+url.slice(OLD_HOLD.length);
    if(url.indexOf(OLD_CHECKOUT)===0)return NEW_CHECKOUT+url.slice(OLD_CHECKOUT.length);
    return url;
  }
  function isConfigUrl(url){
    return url.indexOf(NEW_HOLD)===0&&url.indexOf('action=config')!==-1;
  }
  function shouldAttachToken(url){
    return (url.indexOf(NEW_HOLD)===0&&url.indexOf('action=acquire')!==-1)||url.indexOf(NEW_CHECKOUT)===0;
  }
  function browserFriendlyConfig(response){
    if(!response||!response.ok)return Promise.resolve(response);
    return response.clone().json().then(function(data){
      if(data&&data.campaign){
        data.campaign.active=data.campaign.browsable===true;
        window.dispatchEvent(new CustomEvent('tsume:campaign-access-config',{detail:data.campaign}));
      }
      var headers=new Headers(response.headers);
      headers.set('Content-Type','application/json; charset=utf-8');
      return new Response(JSON.stringify(data),{
        status:response.status,
        statusText:response.statusText,
        headers:headers
      });
    }).catch(function(){return response});
  }
  function inspectAccessFailure(response,url){
    if(!response||response.ok)return;
    if(url.indexOf(NEW_HOLD)!==0&&url.indexOf(NEW_CHECKOUT)!==0)return;
    response.clone().json().then(function(data){
      if(!data)return;
      if(data.code==='EARLY_ACCESS_REQUIRED'||data.code==='EARLY_ACCESS_INVALID'){
        window.dispatchEvent(new CustomEvent('tsume:early-access-required'));
      }
    }).catch(function(){});
  }

  window.fetch=function(input,init){
    var originalUrl=targetUrl(input);
    if(!originalUrl)return nativeFetch(input,init);

    var url=rewriteUrl(originalUrl);
    var next=copyInit(init||{});

    if(shouldAttachToken(url)){
      var payload=parseBody(next.body);
      if(payload){
        payload.earlyAccessToken=getAccessToken();
        next.body=JSON.stringify(payload);
      }
    }

    var requestInput=url===originalUrl?input:url;
    return nativeFetch(requestInput,next).then(function(response){
      var output=isConfigUrl(url)?browserFriendlyConfig(response):Promise.resolve(response);
      return output.then(function(finalResponse){
        inspectAccessFailure(finalResponse,url);
        return finalResponse;
      });
    });
  };

  document.addEventListener('DOMContentLoaded',function(){
    var root=document.querySelector('#TsumePicker');
    if(!root)return;

    var panel=document.createElement('section');
    panel.className='tsume-early-access';
    panel.hidden=true;
    panel.setAttribute('data-tsume-early-access','');
    panel.innerHTML=''
      +'<div class="tsume-early-access__head">'
      +'<div><p class="tsume-early-access__eyebrow">EARLY ACCESS</p><p class="tsume-early-access__title" data-tsume-access-title></p><p class="tsume-early-access__copy" data-tsume-access-copy></p></div>'
      +'<span class="tsume-early-access__badge" data-tsume-access-badge></span>'
      +'</div>'
      +'<p class="tsume-early-access__message" data-tsume-access-message hidden></p>';

    var search=root.querySelector('[data-tsume-search]');
    if(search&&search.parentNode)search.parentNode.insertBefore(panel,search);
    else{
      var inner=root.querySelector('.tsume-picker__inner');
      if(inner)inner.insertBefore(panel,inner.firstChild);
    }

    var signupSource=document.querySelector('[data-tsume-signup-source]');
    var signup=signupSource&&signupSource.querySelector('[data-tsume-signup]');
    var signupComplete=!!(signup&&signup.querySelector('[data-tsume-signup-success]'));
    if(signup){
      signup.hidden=true;
      panel.appendChild(signup);
    }

    var title=panel.querySelector('[data-tsume-access-title]');
    var copy=panel.querySelector('[data-tsume-access-copy]');
    var badge=panel.querySelector('[data-tsume-access-badge]');
    var message=panel.querySelector('[data-tsume-access-message]');
    var currentPhase='UNKNOWN';
    var accessAllowed=false;
    var preparedAccess=!!getAccessToken();
    var inviteError=false;
    var refreshTimer=null;
    var boundaryTimer=null;

    function setMessage(text,isError){
      if(!message)return;
      message.textContent=text||'';
      message.hidden=!text;
      message.classList.toggle('is-error',!!isError);
    }
    function setSignupVisible(visible){
      if(signup)signup.hidden=!visible;
    }
    function setLocked(locked){
      root.classList.toggle('tsume-access-locked',!!locked);
      root.dataset.tsumeAccessAllowed=locked?'false':'true';
    }
    function scrollToAccess(){
      panel.scrollIntoView({behavior:'smooth',block:'center'});
    }
    function closeQuickView(){
      var modal=root.querySelector('.tsume-detail.is-open');
      if(!modal)return;
      var close=modal.querySelector('.tsume-detail__close[data-qv-close]');
      if(close)close.click();
    }
    function updateUi(campaign){
      currentPhase=(campaign&&campaign.phase)||'UNKNOWN';
      panel.hidden=false;
      setSignupVisible(false);
      setMessage('',false);

      if(currentPhase==='PREVIEW'){
        accessAllowed=false;
        setLocked(true);
        if(preparedAccess){
          title.textContent='先行販売の準備ができました';
          copy.textContent='9/18 19:00から、この端末で商品を選べます。';
          badge.textContent='準備完了';
        }else if(signupComplete){
          title.textContent='メール会員登録が完了しました';
          copy.textContent='9/18 19:00に先行販売URLをメールでご案内します。';
          badge.textContent='登録完了';
        }else{
          title.textContent='メール会員なら1日早く参加できます';
          copy.textContent='9/18 18:59までに登録すると、9/18 19:00から先行参加できます。';
          badge.textContent='登録受付中';
          setSignupVisible(true);
        }
        if(inviteError)setMessage('先行アクセスURLを確認できませんでした。一般販売は9/19 19:00からです。',true);
        return;
      }

      if(currentPhase==='EARLY'){
        setLocked(!accessAllowed);
        if(accessAllowed){
          title.textContent='メール会員先行販売中';
          copy.textContent='先行アクセスが有効です。商品を選べます。';
          badge.textContent='参加OK';
        }else{
          title.textContent='先行参加の受付は終了しました';
          copy.textContent='商品は閲覧できます。一般販売は9/19 19:00からです。';
          badge.textContent='閲覧のみ';
          if(inviteError)setMessage('先行アクセスURLを確認できませんでした。',true);
        }
        return;
      }

      if(currentPhase==='PUBLIC'){
        accessAllowed=true;
        preparedAccess=false;
        setLocked(false);
        setSignupVisible(false);
        panel.hidden=true;
        setAccessToken('');
        return;
      }

      accessAllowed=false;
      setLocked(true);
      setSignupVisible(false);
      panel.hidden=true;
    }

    function postNative(url,payload){
      return nativeFetch(url,{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify(payload)
      }).then(function(res){
        return res.json().catch(function(){return {}}).then(function(data){return {res:res,data:data}});
      });
    }
    function claimInvite(){
      if(!pendingInviteKey)return Promise.resolve(false);
      var inviteKey=pendingInviteKey;
      pendingInviteKey='';
      return postNative(ACCESS_URL,{action:'claim',inviteKey:inviteKey}).then(function(result){
        if(result.res.ok&&result.data&&result.data.accessToken){
          setAccessToken(result.data.accessToken);
          preparedAccess=true;
          accessAllowed=result.data.allowed===true;
          inviteError=false;
          window.dispatchEvent(new CustomEvent('tsume:early-access-claimed'));
          return true;
        }
        if(result.data&&result.data.code==='PUBLIC_ACCESS'){
          inviteError=false;
          return false;
        }
        inviteError=true;
        return false;
      }).catch(function(){
        inviteError=true;
        return false;
      });
    }
    function checkStoredAccess(){
      var token=getAccessToken();
      if(!token){
        accessAllowed=false;
        preparedAccess=false;
        return Promise.resolve(false);
      }
      return postNative(ACCESS_URL,{action:'status',accessToken:token}).then(function(result){
        accessAllowed=!!(result.res.ok&&result.data&&result.data.allowed===true&&result.data.phase==='EARLY');
        if(!accessAllowed){
          setAccessToken('');
          preparedAccess=false;
        }else{
          preparedAccess=true;
        }
        return accessAllowed;
      }).catch(function(){
        accessAllowed=false;
        return false;
      });
    }
    function scheduleBoundary(campaign){
      clearTimeout(boundaryTimer);
      var target='';
      if(campaign&&campaign.phase==='PREVIEW')target=campaign.earlyStartsAt||'';
      else if(campaign&&campaign.phase==='EARLY')target=campaign.publicStartsAt||'';
      if(!target)return;
      var delay=new Date(target).getTime()-Date.now()+250;
      if(delay>0&&delay<2147483647)boundaryTimer=setTimeout(refresh,delay);
    }
    function refresh(){
      return nativeFetch(NEW_HOLD+'?action=config',{headers:{Accept:'application/json'}}).then(function(res){
        return res.json().then(function(data){return {res:res,data:data}});
      }).then(function(result){
        if(!result.res.ok||!result.data||!result.data.campaign)throw new Error('CONFIG');
        var campaign=result.data.campaign;
        currentPhase=campaign.phase||'UNKNOWN';
        if(currentPhase==='EARLY'){
          return checkStoredAccess().then(function(){
            updateUi(campaign);
            scheduleBoundary(campaign);
          });
        }
        accessAllowed=currentPhase==='PUBLIC';
        preparedAccess=!!getAccessToken();
        updateUi(campaign);
        scheduleBoundary(campaign);
      }).catch(function(){
        accessAllowed=false;
        setLocked(true);
        setSignupVisible(false);
        panel.hidden=false;
        title.textContent='販売状況を確認しています';
        copy.textContent='少し時間をおいて再読み込みしてください。';
        badge.textContent='確認中';
      });
    }

    document.addEventListener('click',function(event){
      var select=event.target.closest&&event.target.closest('[data-qv-select]');
      if(!select||!root.contains(select))return;
      var locked=currentPhase==='PREVIEW'||(currentPhase==='EARLY'&&!accessAllowed);
      if(!locked)return;
      event.preventDefault();
      event.stopImmediatePropagation();
      closeQuickView();
      if(currentPhase==='EARLY'){
        setMessage('先行アクセス対象者のみ商品を選択できます。一般販売は9/19 19:00からです。',false);
      }else if(signupComplete){
        setMessage('登録ありがとうございます。先行販売URLは9/18 19:00にメールでご案内します。',false);
      }else{
        setMessage('9/18 18:59までにメール会員登録すると、先行販売に参加できます。',false);
      }
      setTimeout(scrollToAccess,80);
    },true);

    window.addEventListener('tsume:campaign-access-config',function(event){
      var campaign=event.detail||{};
      if(campaign.phase&&campaign.phase!==currentPhase)refresh();
    });
    window.addEventListener('tsume:early-access-required',function(){
      accessAllowed=false;
      setAccessToken('');
      preparedAccess=false;
      refresh().then(scrollToAccess);
    });
    document.addEventListener('visibilitychange',function(){if(!document.hidden)refresh()});

    claimInvite().finally(function(){
      refresh();
      refreshTimer=setInterval(refresh,60000);
    });
  });
})();
